import React from 'react'
import { CSVLink } from "react-csv";
import { normalizePhone } from '../../utils/functions/tools/normalizePhone';
import {
  DataTable,
  Table,
  Button,
  Pagination,
  TableBatchAction,
  TableBatchActions,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarAction,
  TableToolbarContent,
  TableToolbarSearch,
  TableToolbarMenu,
  Tag,
  Toggle,
  Modal,
  Form,
  TextInput,
  NotificationActionButton,
  InlineNotification,
  OverflowMenu,
  OverflowMenuItem
} from 'carbon-components-react';
import {
  Delete16 as Delete,
  Edit16 as Edit,
} from '@carbon/icons-react';

const clientListHeaders = [
  { header: "ID", key: "id" },
  { header: "Action", key: "action" },
  { header: "First Name", key: "first_name" },
  { header: "Last Name", key: "last_name" },
  { header: "Status", key: "is_active" },
  { header: "Primary", key: "is_primary" },
  { header: "Email", key: "email" },
  { header: "Phone Number", key: "phoneNumber" },
  { header: "Position", key: "position" },
];

export default {
  title: 'Components/DataTable/Batch Actions',
  component: DataTable,
  subcomponents: {
    TableBatchAction,
    TableBatchActions,
    TableToolbar,
    TableToolbarAction,
    TableToolbarContent,
    TableToolbarSearch,
    TableToolbarMenu,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
  },
};

export const ClientContactsList = ({ editContactSetup, editContactID, setEditContactID, editContact, editContactForm, openEditContactModal, setOpenEditContactModal, deleteContact, contactsToDel, setContactsToDel, openDeleteContactModal, setOpenDeleteContactModal, phoneInput, setPhoneInput, addContact, curDate, addContactForm, openAddContactModal, setOpenAddContactModal, error, setError, activeCheck, rows, totalItems, currentPageSize, setCurrentPageSize, setFirstRowIndex, setContactSearch }: any) => (
  <>
    <DataTable rows={rows} headers={clientListHeaders} isSortable>
      {({
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getSelectionProps,
        getToolbarProps,
        getBatchActionProps,
        onInputChange,
        selectedRows,
        getTableProps,
        getTableContainerProps,
      }) => {
        const batchActionProps = getBatchActionProps();
        return (
          <TableContainer
            {...getTableContainerProps()}>
            <TableToolbar {...getToolbarProps()}>
              <TableBatchActions {...batchActionProps}>
                <TableBatchAction
                  tabIndex={batchActionProps.shouldShowBatchActions ? 0 : -1}
                  renderIcon={Delete}

                >
                  Delete
                </TableBatchAction>
              </TableBatchActions>
              <TableToolbarContent
                aria-hidden={batchActionProps.shouldShowBatchActions}>
                <TableToolbarSearch
                  persistent={true}
                  tabIndex={batchActionProps.shouldShowBatchActions ? -1 : 0}
                  onChange={(e) => setContactSearch(e.target.value)}
                  placeholder="Search clients"
                />
                <TableToolbarMenu
                  tabIndex={batchActionProps.shouldShowBatchActions ? -1 : 0}>
                  <TableToolbarAction>
                    Export to CSV
                  </TableToolbarAction>
                </TableToolbarMenu>
                <Button
                  tabIndex={batchActionProps.shouldShowBatchActions ? -1 : 0}
                  size="small"
                  kind="primary"
                  onClick={() => setOpenAddContactModal(true)}>
                  Add new
                </Button>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header, i) => (
                    <TableHeader key={i} {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow key={i} {...getRowProps({ row })}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {cell.info.header === "is_primary" ? cell.value === true ? <Tag type="green" title="Clear Filter">Yes</Tag>
                          : <Tag type="red" title="Clear Filter">No</Tag> : cell.info.header === "phoneNumber" ? <p>{normalizePhone(cell.value)}</p> : cell.info.header === "is_active" ? cell.value === true ? <Toggle
                            size="sm"
                            labelA="N"
                            labelB="Y"
                            toggled={true}
                            id="primaryCheck"
                            onClick={() => activeCheck(row.id)}
                          />
                            : <Toggle
                              size="sm"
                              labelA="N"
                              labelB="Y"
                              toggled={false}
                              id="primaryCheck"
                              onClick={() => activeCheck(row.id)}
                            /> : cell.info.header === "action" ? <OverflowMenu renderIcon={Edit} className="m-auto">
                              <OverflowMenuItem onClick={() => editContactSetup(row.id) & setOpenEditContactModal(true)} itemText="Edit" />
                              <OverflowMenuItem onClick={() => setContactsToDel(row.id) & setOpenDeleteContactModal(true)} hasDivider isDelete itemText="Delete" />
                            </OverflowMenu> : cell.value}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Pagination
              totalItems={totalItems}
              pageSizes={[10, 20, 30, 40, 50]}
              pageSize={currentPageSize}
              onChange={({ page, pageSize }) => {
                if (pageSize !== currentPageSize) {
                  setCurrentPageSize(pageSize);
                }
                setFirstRowIndex(pageSize * (page - 1));
              }}
            />
          </TableContainer>
        );
      }}
    </DataTable>

    <Modal
      open={openAddContactModal}
      modalHeading="Add Client Contact"
      modalLabel="Client Contacts"
      primaryButtonText="Add"
      secondaryButtonText="Cancel"
      hasForm={true}
      onRequestClose={() => setOpenAddContactModal(false) & setError(false) & setPhoneInput('')}
      onRequestSubmit={() => addContactForm.current && addContactForm.current.click() & setError(false)}
    >   {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to add client contact" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
      <p style={{ marginBottom: '1rem' }}>
        Fill out the form to add a new client contact.
      </p>
      <Form id="addContact" onSubmit={(values) => addContact(values)} className="d-flex flex-w">
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="first_name"
            name="first_name"
            labelText="First Name"
            placeholder="Enter first name"
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="last_name"
            name="last_name"
            labelText="Last Name"
            placeholder="Enter last name"
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="email"
            name="email"
            type="email"
            labelText="Email Address"
            placeholder="Enter email address"
            invalidText="Email address is required"
            style={{ marginBottom: '1rem' }}
            required
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="phoneNumber"
            name="phoneNumber"
            labelText="Phone Number"
            placeholder="Enter phone number"
            onChange={((e) => setPhoneInput(normalizePhone(e.target.value)))}
            value={phoneInput}
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="position"
            name="position"
            labelText="Position"
            placeholder="Enter position"
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <input type="submit" style={{ display: 'none' }} ref={addContactForm} />
      </Form>
    </Modal>

    <Modal
      open={openEditContactModal}
      modalHeading="Edit Client Contact"
      modalLabel="Client Contacts"
      primaryButtonText="Save Changes"
      secondaryButtonText="Cancel"
      hasForm={true}
      onRequestClose={() => setOpenEditContactModal(false) & setError(false) & setPhoneInput('')}
      onRequestSubmit={() => editContactForm.current && editContactForm.current.click() & setError(false)}
    >   {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to add client contact" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
      <p style={{ marginBottom: '1rem' }}>
        Fill out the form to add a new client contact.
      </p>
      <Form onSubmit={(values) => editContact(values)} className="d-flex flex-w">
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="first_name"
            name="first_name"
            labelText="First Name"
            placeholder="Enter first name"
            defaultValue={editContactID.first_name}
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="last_name"
            name="last_name"
            labelText="Last Name"
            placeholder="Enter last name"
            defaultValue={editContactID.last_name}
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="email"
            name="email"
            type="email"
            labelText="Email Address"
            placeholder="Enter email address"
            invalidText="Email address is required"
            defaultValue={editContactID.email}
            style={{ marginBottom: '1rem' }}
            required
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="phoneNumber"
            name="phoneNumber"
            labelText="Phone Number"
            placeholder="Enter phone number"
            onChange={((e) => setPhoneInput(normalizePhone(e.target.value)))}
            value={phoneInput}
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <div className="col-12 col-md-6 m-005">
          <TextInput
            data-modal-primary-focus
            id="position"
            name="position"
            labelText="Position"
            placeholder="Enter position"
            defaultValue={editContactID.position}
            style={{ marginBottom: '1rem' }}
          />
        </div>
        <input type="submit" style={{ display: 'none' }} ref={editContactForm} />
      </Form>
    </Modal>

    <Modal
      danger
      open={openDeleteContactModal}
      modalHeading="Delete Client Contact"
      modalLabel="Client Contacts"
      primaryButtonText="Delete"
      secondaryButtonText="Cancel"
      onRequestClose={() => setOpenDeleteContactModal(false) & setError(false)}
      onRequestSubmit={() => deleteContact(contactsToDel)}
    >
      {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to delete client address" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
      <p>Are you sure you want to delete the selected client contacts?</p>

    </Modal>
  </>
);